<app-auth-page-layout>
  <div class="flex flex-col flex-1 w-full overflow-y-auto lg:w-1/2 no-scrollbar">
    <div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto py-8">

      @if (state() === 'checking') {
        <div class="flex flex-col items-center gap-4 text-center" role="status" aria-live="polite">
          <div class="w-10 h-10 border-4 border-brand-500 border-t-transparent rounded-full animate-spin"></div>
          <p class="text-sm text-gray-500 dark:text-gray-400">Checking your account…</p>
        </div>
      } @else {
        <div class="mb-6 sm:mb-8">
          <h1 class="mb-3 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
            Confirm you’re 18 or over
          </h1>
          <p class="text-sm leading-relaxed text-gray-500 dark:text-gray-400">
            Safeword is for adults only. Before you can see posts, events and messages, we need to
            confirm your age. It usually takes less than two minutes.
          </p>
        </div>

        @if (lastOutcome === 'failed' && state() !== 'error') {
          <div class="mb-6 rounded-xl border border-error-500/30 bg-error-50 px-4 py-3 text-sm text-error-700 dark:bg-error-500/10 dark:text-error-400" role="alert">
            Your last attempt couldn’t confirm your age. You can try again, and choosing a
            different method often helps.
          </div>
        }
        @if (lastOutcome === 'expired' && state() !== 'error') {
          <div class="mb-6 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-600 dark:border-gray-800 dark:bg-white/[0.03] dark:text-gray-400">
            Your previous verification link expired. Start again below.
          </div>
        }
        @if (state() === 'error') {
          <div class="mb-6 rounded-xl border border-error-500/30 bg-error-50 px-4 py-3 text-sm text-error-700 dark:bg-error-500/10 dark:text-error-400" role="alert">
            {{ errorMessage() }}
          </div>
        }

        <div class="mb-8 space-y-3 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
          <p>
            Verification is carried out by <span class="font-medium text-gray-800 dark:text-white/90">VerifyMy</span>,
            an independent age assurance provider. You’ll choose how to verify on their page, for example
            with your email address, a quick selfie age estimate or a photo ID.
          </p>
          <p>
            Safeword only receives the result: whether you’re over 18. We never see your ID or selfie.
          </p>
        </div>

        <button type="button"
          (click)="startVerification()"
          [disabled]="state() === 'redirecting'"
          class="flex w-full items-center justify-center gap-2 rounded-xl bg-brand-500 px-4 py-3 text-sm font-medium text-white transition hover:bg-brand-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-500/30 disabled:cursor-wait disabled:opacity-70">
          @if (state() === 'redirecting') {
            <span class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" aria-hidden="true"></span>
            Opening VerifyMy…
          } @else if (canResume) {
            Continue verification
          } @else {
            Verify my age
          }
        </button>

        <p class="mt-6 text-center text-xs leading-relaxed text-gray-500 dark:text-gray-400">
          Read our <a routerLink="/legal/age-verification" class="text-brand-500 hover:underline">Age Verification Policy</a>
          and <a routerLink="/legal/privacy-policy" class="text-brand-500 hover:underline">Privacy Policy</a>.
          Not ready?
          <button type="button" (click)="signOut()" [disabled]="signingOut()"
            class="text-gray-700 underline-offset-2 hover:underline dark:text-gray-300">
            Sign out
          </button>
        </p>
      }
    </div>
  </div>
</app-auth-page-layout>
